import { useState } from 'react';
import { fetchCountryStates } from 'api';
import { useAxios, useVariable } from 'hooks';
import { IError } from 'types';
import { checkIfError } from 'utils/helpers';
import { AxiosResponse } from 'axios';

const useFetchCountryStates = () => {
  const [request, { loading, error }] = useAxios<{ name: string; iso2: string }[]>();
  const [cachedCountryStates, setCachedCountryStates] = useVariable<Record<string, { name: string; iso2: string }[]>>(
    {}
  );

  const [countryStates, setCountryStates] = useState<
    { name: string; iso2: string }[] | AxiosResponse<IError, IError>
  >();

  const handleFetchCountryStates = async (id: string) => {
    if (cachedCountryStates[id]) {
      setCountryStates(cachedCountryStates[id]);
      return cachedCountryStates[id];
    }
    const states = await request(fetchCountryStates(id));

    if (!checkIfError(states)) {
      setCachedCountryStates((prevcachedCountryStates) => ({
        ...prevcachedCountryStates,
        [id]: states,
      }));
    }

    setCountryStates(states);
    return states;
  };

  return [handleFetchCountryStates, { loading, error: error?.data?.message, data: countryStates }] as const;
};

export { useFetchCountryStates };
